"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeFromCartCreator = void 0;
var util_1 = require("./util");
var removeFromCartCreator = function (event) {
    return (0, util_1.removeFromCartEvent)(event, 'cart-remove');
};
exports.removeFromCartCreator = removeFromCartCreator;
